"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateInteger = exports.integerSchema = void 0;
var zod = _interopRequireWildcard(require("zod"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const integerSchema = exports.integerSchema = zod.string().transform(val => {
  const parsed = Number.parseInt(val, 10);
  if (Number.isNaN(parsed)) {
    return undefined;
  }
  return parsed;
});

/**
 * Validates the provided string against the integer schema and converts it to integer.
 *
 * @param input - The string to validate.
 * @returns The validated integer if successful, otherwise undefined.
 */
const validateInteger = input => {
  if (input === undefined) {
    return undefined;
  }
  const result = integerSchema.safeParse(input);
  if (result.success) {
    return result.data;
  }
  return undefined;
};
exports.validateInteger = validateInteger;
//# sourceMappingURL=validateInteger.js.map